// extracted by mini-css-extract-plugin
module.exports = {"context-panel-section":"section_context-panel-section__tniUX","section-title":"section_section-title__Xa_5v","section-content":"section_section-content__GDPI3"};